import { Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ClientHome } from './pages/ClientHome';
import { ClientDocuments } from './pages/ClientDocuments';
import { SignDocument } from './pages/SignDocument';
import { ClientProfile } from './pages/ClientProfile';
import { LawityDashboard } from './pages/LawityDashboard';
import { BriefingPage } from './pages/BriefingPage';
import { Messages } from './pages/Messages';
import { Notifications } from './pages/Notifications';
import { Login, SignUp } from './pages/Auth';

// Create a query client with default options
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        <Route path="/" element={<ClientHome />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/dashboard" element={<LawityDashboard />} />
        <Route path="/briefing" element={<BriefingPage />} />
        <Route path="/documents" element={<ClientDocuments />} />
        <Route path="/sign/:documentId" element={<SignDocument />} />
        <Route path="/profile" element={<ClientProfile />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </QueryClientProvider>
  );
}
